import { useEffect, useState } from "react";
import { ItemsDetail } from "./itemDetail/Detail";
import { ItemsList } from "./itemList/List";
import { ItemsType } from "./itemType/Type";
import { ItemTypeInit } from "./itemType/init/TypeInit";
import { typesDetailInit } from "./itemList/init/TypeListInit";

export const Items = () => {

    const [types, setTypes] = useState(ItemTypeInit)
    const [typesDetail, setTypesDetail] = useState(typesDetailInit)
    const [menuId, setMenuId] = useState(1)
    const [isAddItem, setIsAddItem] = useState(false)
    const [isModify, setIsModify] = useState(false)
    const [isAddComplete, setIsAddComplete] = useState(false)
    const [isDeleteComplete, setIsDeleteComplete] = useState(false)
    
    useEffect(()=>{
        setIsAddItem(false)
    },[typesDetail])

    return (
        <>
            <div className="items_boxes_outer">
                <ItemsType 
                    types={types}
                    setTypes={setTypes}
                    menuId={menuId}
                    setMenuId={setMenuId}
                />
                <ItemsList 
                    types={types}
                    typesDetail={typesDetail}
                    setTypesDetail={setTypesDetail}
                    menuId={menuId}
                    isAddItem={isAddItem}
                    setIsAddItem={setIsAddItem}
                    isModify={isModify}
                    setIsModify={setIsModify}
                    isAddComplete={isAddComplete}
                    setIsAddComplete={setIsAddComplete}
                    isDeleteComplete={isDeleteComplete}
                    setIsDeleteComplete={setIsDeleteComplete}
                />
                <ItemsDetail 
                    types={types}
                    typesDetail={typesDetail}
                    menuId={menuId}
                    isAddItem={isAddItem}
                    setIsAddItem={setIsAddItem}
                    setIsModify={setIsModify}
                    setIsAddComplete={setIsAddComplete}
                    setIsDeleteComplete={setIsDeleteComplete}
                />
            </div>
        </>
    );
}